import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "common-app-container"
};
var _hoisted_2 = {
  class: "title-container"
};
var _hoisted_3 = {
  class: "content-container"
};
var _hoisted_4 = {
  key: 0,
  class: "app-list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "item-name"
};
var _hoisted_8 = {
  key: 1,
  class: "common-empty"
};
var _hoisted_9 = ["src"];
import { ref } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getCommonAppList } from '@/api/home';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { appAliasEvent } from '@/utils/auth.js';
export default {
  __name: 'CommonApp',
  setup: function setup(__props) {
    var noData = require('@/assets/noData.svg');
    var list = ref([]);
    var loading = ref(false);
    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              loading.value = true;
              _context.n = 1;
              return getCommonAppList();
            case 1:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                list.value = data || [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '应用获取失败');
            case 3:
              _context.p = 3;
              loading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();
    getList();
    var openApp = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var appUrl;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return appAliasEvent(item);
            case 1:
              appUrl = _context2.v;
              if (appUrl) {
                skipUrlOpen(appUrl);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function openApp(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "common-icon",
        size: "24",
        class: "icon"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "常用应用", -1))]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_loading, {
        loading: loading.value
      }, null, 8, ["loading"]), !loading.value && list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "app-item",
          key: item.appId,
          onClick: function onClick($event) {
            return openApp(item.appAlias);
          }
        }, [_createElementVNode("img", {
          src: item.appIcon,
          fit: "cover",
          class: "item-icon"
        }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.appName), 1)], 8, _hoisted_5);
      }), 128))])) : _createCommentVNode("", true), !loading.value && !list.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
        src: _unref(noData),
        height: "92"
      }, null, 8, _hoisted_9), _cache[1] || (_cache[1] = _createElementVNode("span", null, "暂无数据", -1))])) : _createCommentVNode("", true)])]);
    };
  }
};